import React from "react";
import { FaInstagram, FaTiktok, FaYoutube, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";

export default function Footer() {
  // const [email, setEmail] = useState("");
  // const [isLoading, setIsLoading] = useState(false);
  // const [isSuccess, setIsSuccess] = useState(false);
  // const [error, setError] = useState("");
  const socialLinks = [
    { Icon: FaInstagram, link: "https://instagram.com/yourpage" },
    { Icon: FaTiktok, link: "https://tiktok.com/@yourpage" },
    { Icon: FaYoutube, link: "https://youtube.com/yourchannel" },
    { Icon: FaXTwitter, link: "https://twitter.com/yourpage" },
    { Icon: FaFacebook, link: "https://facebook.com/yourpage" },
  ];

  // const handleSubscribe = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   setError("");
  //   setIsSuccess(false);

  //   try {
  //     const response = await fetch("https://api.brevo.com/v3/contacts", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "api-key": process.env.REACT_APP_BREVO_API_KEY,
  //       },
  //       body: JSON.stringify({
  //         email: email,
  //         listIds: [3],
  //       }),
  //     });

  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       throw new Error(errorData.message || "Subscription failed");
  //     }

  //     setIsSuccess(true);
  //     setEmail("");
  //   } catch (err) {
  //     setError(err.message || "An error occurred. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <footer className="flex flex-col gap-10 pt-12 bg-white border-t-4 border-b-2 border-black">
      {/* Logo & Links Section */}
      <div className="w-[80%] mx-auto flex max-lg:flex-col max-lg:gap-10 justify-between py-12 max-md:w-[90%]">
        {/* Logo & Branding */}
        <div className="w-[45%] max-lg:w-full flex flex-col gap-6 items-start max-sm:items-center text-center">
          <img
            src={"/TEH X AFRICA 1.png"}
            alt="Tech X Africa Logo"
            className="w-[300px] max-lg:w-[220px] max-sm:w-[150px] h-auto object-contain mx-auto"
          />
          <h2 className="text-3xl max-lg:text-2xl max-sm:text-lg text-black font-medium text-center">
            By <span className="font-black">ATC Africa</span>
          </h2>
        </div>

        {/* Navigation Links */}
        <div className="w-[45%] max-lg:w-full flex justify-between border-l-4 max-lg:border-none pl-12 max-lg:pl-0 max-md:flex-col max-md:items-center max-md:gap-10 text-center">
          <div className="flex flex-col gap-3 items-start max-md:items-center">
            <h3 className="font-semibold text-2xl max-lg:text-lg text-black">
              Resources
            </h3>
            <Link
              to="/shop"
              className="cursor-pointer text-sm max-lg:text-xs hover:text-red-600 transition"
            >
              Shop
            </Link>
          </div>

          <div className="flex flex-col gap-3 items-center">
            <h3 className="font-semibold text-2xl max-lg:text-lg text-black">
              Quick Links
            </h3>
            {/* <Link
              to="/hackathon"
              className="cursor-pointer text-sm max-lg:text-xs hover:text-red-600 transition"
            >
              Hackathon
            </Link> */}
            <Link
              to="/speakers"
              className="cursor-pointer text-sm max-lg:text-xs hover:text-red-600 transition"
            >
              Speakers
            </Link>
            <Link
              to="/sponsorUs"
              className="cursor-pointer text-sm max-lg:text-xs hover:text-red-600 transition"
            >
              Sponsors
            </Link>

            {/* Social Media Icons */}
            <div className="flex gap-5 mt-8 justify-center flex-wrap">
              {socialLinks.map(({ Icon, link }, index) => (
                <a
                  key={index}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer text-black hover:text-red-600 transition"
                >
                  <Icon size={25} />
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3 items-start max-md:items-center">
            <h3 className="font-semibold text-2xl max-lg:text-lg text-black">
              About
            </h3>
            <Link
              to="/about"
              className="cursor-pointer text-sm max-lg:text-xs hover:text-red-600 transition"
            >
              About TXA
            </Link>
          </div>
        </div>
      </div>

      {/* Newsletter Section */}
      {/* 
      <div className="w-[80%] mx-auto bg-[#F63A0A] text-white p-10 rounded-xl shadow-lg flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <h3 className="text-3xl font-semibold">Stay Updated!</h3>
          <p className="text-lg opacity-90">
            Subscribe to our newsletter for the latest updates.
          </p>
        </div>

        <form onSubmit={handleSubscribe} className="w-full md:w-[50%]">
          <div className="flex flex-col gap-3">
            <div className="flex bg-white rounded-lg overflow-hidden shadow-md">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full p-3 text-black outline-none"
                required
              />
              <button
                type="submit"
                disabled={isLoading}
                className="bg-black px-6 py-3 text-white font-medium hover:bg-amber-800 transition-all disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isLoading ? "Submitting..." : "Subscribe"}
              </button>
            </div>

            {error && (
              <p className="text-red-200 text-sm text-center">{error}</p>
            )}
            {isSuccess && (
              <p className="text-green-200 text-sm text-center">
                Successfully subscribed!
              </p>
            )}
          </div>
        </form>
      </div>
      */}

      {/* Copyright Section */}
      <div className="w-full py-5 bg-[#3B0100] flex items-center justify-center text-center">
        <p className="text-lg max-md:text-sm text-white tracking-wide px-4">
          © 2025 Tech X Africa. All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
